export default __webpack_public_path__ + "static/media/journeytray-bluetree.1dfb881b.svg";